import { create } from 'zustand';
import { getStoredTheme } from '@/lib/theme';
/**
 * Zustand store wrapping the theme choice. The `theme` module handles
 * persistence + DOM mutation; this store is purely the reactive wrapper.
 */
export const useThemeStore = create((set) => ({
    theme: getStoredTheme(),
    setTheme: (theme) => set({ theme }),
}));
